import React, { PropsWithChildren, useEffect, useState } from "react";
import { BootLineupProps, ILineupContext, isCompleteLineupContext, LineupContext, SyncStatus, useLineupContextVal } from "./LineupContext"
import { ILineup, LineupOption, LineupOptionID } from "../types";
import { MOCKED_OPTIONS_VERSION, mockedScenario, Scenario, ScenarioName, scenarioNames } from "./mockedScenarios";

const ScenarioEntry: React.FC<PropsWithChildren<{selected: boolean, onSelect(): void}>> = ({selected, onSelect, children}) => {
  return <div className="neo__lineupMocks__scenario">
    {selected
      ? <span>{`→ ${children}`}</span>
      : <a onClick={onSelect}>{children}</a>}
  </div>
}

export const MockedLineupContext: React.FC<React.PropsWithChildren<BootLineupProps & {initialMockScenario?: ScenarioName}>> = ({children, initialMockScenario, ...props}) => {
  initialMockScenario || (initialMockScenario = 'initial');

  const [ lastSentRequests, setLastSentRequests ] = useState<string[]>([]);
  const [ selectedScenario, setSelectedScenario ] = useState<ScenarioName>(initialMockScenario);

  const [state, setState] = useState<Partial<ILineupContext>>({
    ...mockedScenario(selectedScenario),
    action: (actions) => setLastSentRequests((prev) => [...prev, `ACTION(${actions.map((a) =>
      `${a.type}-${(a as any).slot ?? ''}-${(a as any).slot1 ?? ''}-${(a as any).slot2 ?? ''}-${(a as any).option ?? ''}`).join(', ')})`]),
    optionsVersion: MOCKED_OPTIONS_VERSION,
  });

  const setLineupSyncStatus = (status?: SyncStatus) => {
    setState((prev) => ({
      ...prev,
      lineupSyncStatus: status,
    }))
  };

  const setOptionsSyncStatus = (status?: SyncStatus) => {
    setState((prev) => ({
      ...prev,
      optionsSyncStatus: status,
    }))
  };

  const contextVal = useLineupContextVal(state as ILineupContext);

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      ...mockedScenario(selectedScenario)
    }));
  }, [selectedScenario]);
  
  return isCompleteLineupContext(contextVal)
    ? <LineupContext.Provider value={contextVal}>
        <div className="neo__lineupMocks">
          {lastSentRequests.length > 0 &&
            <div className="neo__lineupMocks__lastSentRequest">
              {lastSentRequests[lastSentRequests.length - 1]}
            </div>}
          <div className="neo__lineupMocks__scenarios">
            <div>
              {scenarioNames().map((n) => {
                const selected = selectedScenario === n;
                return <ScenarioEntry key={n} selected={selectedScenario === n} onSelect={() => setSelectedScenario(n)}>{n}</ScenarioEntry>
              })}
            </div>
            <div>
              <ScenarioEntry selected={!state.lineupSyncStatus} onSelect={() => setLineupSyncStatus(undefined)}>lineupSyncStatus: undefined</ScenarioEntry>
              <ScenarioEntry selected={state.lineupSyncStatus === 'synching'} onSelect={() => setLineupSyncStatus('synching')}>lineupSyncStatus: synching</ScenarioEntry>
              <ScenarioEntry selected={state.lineupSyncStatus === 'couldNotSync'} onSelect={() => setLineupSyncStatus('couldNotSync')}>lineupSyncStatus: couldNotSync</ScenarioEntry>
              <ScenarioEntry selected={state.lineupSyncStatus === 'synchingDone'} onSelect={() => setLineupSyncStatus('synchingDone')}>lineupSyncStatus: synchingDone</ScenarioEntry>
              <ScenarioEntry selected={!state.optionsSyncStatus} onSelect={() => setOptionsSyncStatus(undefined)}>optionsSyncStatus: undefined</ScenarioEntry>
              <ScenarioEntry selected={state.optionsSyncStatus === 'synching'} onSelect={() => setOptionsSyncStatus('synching')}>optionsSyncStatus: synching</ScenarioEntry>
              <ScenarioEntry selected={state.optionsSyncStatus === 'couldNotSync'} onSelect={() => setOptionsSyncStatus('couldNotSync')}>optionsSyncStatus: couldNotSync</ScenarioEntry>
              <ScenarioEntry selected={state.optionsSyncStatus === 'synchingDone'} onSelect={() => setOptionsSyncStatus('synchingDone')}>optionsSyncStatus: synchingDone</ScenarioEntry>
            </div>
          </div>
        </div>
        {children}
      </LineupContext.Provider>
    : <div>Lineup Context incomplete</div>
}
